'use client';

import { useTranslations } from 'next-intl';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/shared/ui/shadcn/dialog';
import { useQuickFeedbackStore } from '../model/quick-feedback.store';
import { QuickFeedbackComposer } from './QuickFeedbackComposer';

/**
 * Phone-sized presentation of the quick feedback composer. Mounted ONCE in the
 * app shell and raised from any page's ⋮ menu (`FeedbackMenuItem`). Wide screens open
 * the same form in the header popover (`FeedbackHeaderButton`); on phones the
 * header has no room for a labelled action, so the entry point is an item in
 * the page's ⋮ menu. Mirrors Apple's compact sheet and Android's dialog.
 */
export function FeedbackQuickDialog() {
  const t = useTranslations('feedback');
  const isOpen = useQuickFeedbackStore((state) => state.isOpen);
  const close = useQuickFeedbackStore((state) => state.close);

  return (
    <Dialog open={isOpen} onOpenChange={(next) => !next && close()}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle>{t('quick.button')}</DialogTitle>
        </DialogHeader>
        <QuickFeedbackComposer onSent={close} />
      </DialogContent>
    </Dialog>
  );
}
